export default __webpack_public_path__ + "static/media/Carrusel_02.70e8e4bb.png";